import LogBuffer from '../logbuffer';
/**
 * options.host = (Default: localhost) Remote host of the HTTP logging endpoint
 * options.port = (Default: 80 or 443) Remote port of the HTTP logging endpoint
 * options.path = (Default: /) Remote URI of the HTTP logging endpoint
 * options.auth = (Default: None) An object with username and password attributes for HTTP Basic Auth
 * options.ssl = (Default: false) Value indicating if we should us HTTPS
 * options.interval = milliseconds inrteval which should trigger log sending to BE API
 * options.reportRedux = (Default: false) Value indicating if redux logs should be send to BE API
 */ // let lastLogReport;
let configuration;
// TODO replace with fetch
const _reportError = (config, logBatch)=>{
    if (!logBatch || logBatch.length === 0) {
        return;
    }
    const auth = config.auth && `${config.auth.username}:${config.auth.password}`;
    const url = `${config.ssl ? 'https' : 'http'}://${config.host}${config.port ? ':' : ''}${config.port ? config.port : ''}${config.path}`;
    const xhttp = new XMLHttpRequest();
    xhttp.open('POST', url, true);
    xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    if (auth) {
        xhttp.setRequestHeader('Authorization', `Basic ${btoa(auth)}`);
    }
    xhttp.send(JSON.stringify(logBatch));
};
const _defaultOptions = {
    path: '/',
    auth: undefined,
    ssl: false,
    interval: 5000,
    logTypes: []
};
const LogReporter = {
    configure (options) {
        if (!options) {
            return;
        } else if (!options.host) {
            console.error('You have provided http object for createLogger from @gef-ui/logging,' + ' but you have not specified http.host attribute.');
            return;
        }
        configuration = {
            ..._defaultOptions,
            ...options
        };
        setInterval(()=>{
            // const now = new Date();
            // const logBatch = LogBuffer.filterLogs(lastLogReport, now, configuration.logtypes);
            const logBatch = LogBuffer.filterLogsByType(configuration.logtypes);
            _reportError(configuration, logBatch);
            // lastLogReport = now;
            // TODO clear buffer
            LogBuffer.clear();
        }, configuration.interval);
    },
    report () {
        if (!configuration) {
            return;
        }
        const logBatch = LogBuffer.getLogs();
        _reportError(configuration, logBatch);
        // lastLogReport = new Date();
        // TODO clear buffer
        LogBuffer.clear();
    }
};
export default LogReporter;
